import ApiService from "../apiService";
import { get, patch, post, destroy } from "../apiService";

const _ = require("lodash");
const model = "patients";
export default class PatientService extends ApiService {
  findAll(searchTerm) {
    return get("/patients", {
      params: {
        include: "user,patientCondition.condition,clinician",
        "filter[search]": searchTerm
      }
    });
  }

  find(id) {
    return get(`/patients/${id}`, {
      params: {
        include:
          "user,supportUser,clinician,clinician.user,patientCondition.condition,patientCondition.clinician.user,patientCondition.guestClinicians.user,patientProgram.program,patientProgram.patientProgramItem.task,patientGoal.patientGoalFeedback"
      }
    });
  }

  findProgram(id) {
    return get(`/patient-programs/${id}`, {
      params: {
        include: "patientProgramItem.task,program"
      }
    });
  }

  findProgramActivity(id) {
    return get(`/patient-program-activities`, {
      params: {
        "filter[patientProgramItemId]": id,
        include: "patientProgramItem.task,user"
      }
    });
  }

  sendReminder(id) {
    return post(`/patients/${id}/send_reminder`, {
      data: { type: "patient", id: id }
    });
  }

  sendPushNotification(id) {
    return post(`/patients/${id}/send_push_notification`, {
      data: { type: "patient", id: id }
    });
  }
  saveUser(user) {
    // TODO: extract this out to a more general use model parsing function
    delete user["links"];

    delete user.attributes["acceptedTerms"];
    delete user.attributes["resetPasswordToken"];
    delete user.attributes["userRoles"];

    // TODO: wrap this, along with PUT/POST methods into a general save function, that can check for an id and contruct a url/use the correct method based on the model

    if (user.id) {
      return patch(`/users/${user.id}`, { data: user });
    } else {
      let userToSave = Object.assign({}, user);
      userToSave.type = "users";
      delete userToSave.attributes["confirmEmail"];
      return post(`/users/`, { data: userToSave });
    }
  }

  removeSupportUser(patient) {
    return destroy(`/patients/${patient.id}/remove_support_user`, {});
  }

  savePatient(patient) {
    return this.baseSave(model, patient);
  }

  linkProgram(program) {
    return post(`/patient-programs/copy/`, { data: program });
  }

  savePatientCondition(conditionToSave) {
    var condition = _.cloneDeep(conditionToSave);

    // TODO: extract this out to a more general use model parsing function
    delete condition["links"];
    delete condition.account;
    delete condition.clinician;

    // TODO: wrap this, along with PUT/POST methods into a general save function, that can check for an id and contruct a url/use the correct method based on the model
    if (condition.id) {
      delete condition.relationships.patient["links"];
      delete condition.relationships.clinician["links"];
      delete condition.relationships.condition["links"];
      delete condition.relationships.account["links"];
      delete condition.relationships.patient["related"];
      delete condition.relationships.clinician["related"];
      delete condition.relationships.condition["related"];
      delete condition.relationships.account["related"];

      return patch(`/patient-conditions/${condition.id}`, { data: condition });
    } else {
      return post(`/patient-conditions/`, { data: condition });
    }
  }

  archivePatient(patient) {
    return this.baseArchive(model, patient);
  }
  archivePatientCondition(condition) {
    return this.baseArchive("patient-conditions", condition);
  }

  archivePatientProgram(program) {
    return this.baseArchive("patient-programs", program);
  }
  archivePatientProgramItem(item) {
    return this.baseArchive("patient-program-items", item);
  }

  savePatientProgram(program) {
    var programToSave = _.cloneDeep(program);

    return patch(`/patient-programs/${programToSave.data.id}`, {
      data: programToSave.data,
      relationships: programToSave.relationships
    });
  }

  savePatientProgramItem(programItem) {
    var item = _.cloneDeep(programItem);
    item.relationships.patientProgram = {
      data: {
        id: "" + item.attributes.patientProgramId,
        type: "patient-programs"
      }
    };

    item.relationships.task = {
      data: {
        id: "" + item.attributes.taskId,
        type: "tasks"
      }
    };
    delete item.attributes["missed"];
    delete item.attributes["complete"];
    //delete item["task"];
    //delete item["patientProgram"];
    //delete item.attributes["totalDays"];
    //delete item["days"];
    //delete item["startDate"];
    //delete item.relationships.task["links"];
    //delete item.relationships.patientProgram["links"];
    //delete item.relationships["patientProgramActivity"];

    return this.baseSave("patient-program-items", item);
  }
}



// WEBPACK FOOTER //
// ./src/services/patientService/index.js